import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import ExpertDashboard from "@/pages/ExpertDashboard";
import AuthGate from "@/components/AuthGate";

export const Route = createFileRoute("/expert-dashboard")({
  head: () => seoHead("/expert-dashboard"),
  component: () => (
    <AuthGate><ExpertDashboard /></AuthGate>
  ),
});
